import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import {
  TableLegacy,
  TableLegacyContainer,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTBody,
} from "../../../../components/table/TableLegacy";
import { useIntegrationList } from "../../../../hooks/api/v2/integration/useIntegrationList";
import { ConnectionIntegrationValueCreate } from "./ConnectionIntegrationValueCreate";
import { ConnectionIntegrationValuesUpdate } from "./ConnectionIntegrationValuesUpdate";

export function ConnectionIntegrationModal({
  active,
  onDismiss,
  connection,
}: {
  active: boolean;
  onDismiss: () => void;
  connection: SupplierRelationshipGetResponseType;
}): ReactElement | null {
  const integrationQuery = useIntegrationList({
    query: [
      {
        type: "supplierRetailerConnectionId",
        value: connection.id,
        modifier: "EQUALS",
      },
    ],
  });

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={`${connection.Retailer.Business.name} - Map Customer`}
        description={
          "Enter the appropriate ID for this customer so we can correctly identify them when sending and receiving data via your integrations."
        }
      />
      <DialogContent>
        {!integrationQuery.data?.pages[0]?.length ? (
          <div>You need to connect to your accounting integration first</div>
        ) : (
          <TableLegacyContainer>
            <TableLegacy>
              <TableLegacyTHead>
                <TableLegacyTR>
                  <TableLegacyTH>Integration</TableLegacyTH>
                  <TableLegacyTH>Identifier</TableLegacyTH>
                  <TableLegacyTH>
                    <span />
                  </TableLegacyTH>
                  <TableLegacyTH>Help guide</TableLegacyTH>
                </TableLegacyTR>
              </TableLegacyTHead>
              <TableLegacyTBody>
                {integrationQuery.data.pages[0].map((integration) => (
                  <>
                    {integration.SupplierRetailerConnectionIntegrationValues[0]
                      ?.id ? (
                      <ConnectionIntegrationValuesUpdate
                        integration={integration}
                        connectionId={parseInt(connection.id.toString())}
                        integrationValueId={
                          integration
                            .SupplierRetailerConnectionIntegrationValues[0].id
                        }
                      />
                    ) : (
                      <ConnectionIntegrationValueCreate
                        integration={integration}
                        connectionId={parseInt(connection.id.toString())}
                      />
                    )}
                  </>
                ))}
              </TableLegacyTBody>
            </TableLegacy>
          </TableLegacyContainer>
        )}
      </DialogContent>
    </Dialog>
  );
}
